/** What became of each file in a batch move. */
export interface MoveFilesResult {
  moved: string[];
  /** Refused because an expense is holding the file. */
  locked: string[];
  /** Refused for any other reason. */
  failed: string[];
}

const files = (count: number) => `${count} ${count === 1 ? 'file' : 'files'}`;

/**
 * What to tell the user after a move, or null when there is nothing worth
 * saying.
 *
 * A move where everything went through needs no toast: the files leave the list
 * in front of the user, which says it better than a notification would. It is
 * only the ones that stayed behind that need explaining.
 */
export function describeMoveResult(
  { moved, locked, failed }: MoveFilesResult,
  folderName: string,
): string | null {
  if (locked.length === 0 && failed.length === 0) return null;

  const parts: string[] = [];
  if (moved.length > 0) parts.push(`${files(moved.length)} moved to ${folderName}.`);
  if (locked.length > 0) {
    parts.push(
      `${files(locked.length)} ${locked.length === 1 ? 'is' : 'are'} attached to an expense and stayed put.`,
    );
  }
  if (failed.length > 0) parts.push(`${files(failed.length)} couldn't be moved.`);

  return parts.join(' ');
}
